import { render, staticRenderFns } from "./MainAccount.vue?vue&type=template&id=6bda38f8&scoped=true"
import script from "./MainAccount.vue?vue&type=script&lang=js"
export * from "./MainAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda38f8",
  null
  
)

export default component.exports